import CloseIcon from '@mui/icons-material/Close'
import { Box, Drawer, IconButton, Typography } from '@mui/material'

/**
 * Right-side drawer for creating / editing mentor event types.
 * Keeps focus on one vertical flow with a fixed header and scrollable body.
 */
export default function EventTypeFormDrawer({
  open,
  onClose,
  title,
  subtitle,
  children,
  anchor = 'right',
}) {
  return (
    <Drawer
      anchor={anchor}
      open={open}
      onClose={onClose}
      slotProps={{
        backdrop: {
          sx: { backgroundColor: 'rgba(15, 23, 42, 0.45)' },
        },
      }}
      PaperProps={{
        elevation: 8,
        sx: {
          width: { xs: '100%', sm: 'min(100%, 560px)', md: 600 },
          maxWidth: '100vw',
          display: 'flex',
          flexDirection: 'column',
          borderLeft: { sm: '1px solid' },
          borderColor: { sm: 'divider' },
          bgcolor: 'background.paper',
        },
      }}
    >
      <Box
        component="header"
        sx={{
          flexShrink: 0,
          px: { xs: 2, sm: 2.5 },
          py: 2,
          borderBottom: '1px solid',
          borderColor: 'divider',
          background: (theme) =>
            `linear-gradient(180deg, ${theme.palette.grey[50]} 0%, ${theme.palette.background.paper} 100%)`,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 2 }}>
          <Box sx={{ minWidth: 0 }}>
            <Typography
              variant="h6"
              component="h2"
              sx={{
                fontWeight: 700,
                fontSize: { xs: '1.1rem', sm: '1.25rem' },
                lineHeight: 1.35,
                letterSpacing: '-0.02em',
              }}
            >
              {title}
            </Typography>
            {subtitle ? (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, maxWidth: 480 }}>
                {subtitle}
              </Typography>
            ) : null}
          </Box>
          <IconButton
            onClick={onClose}
            aria-label="Close"
            size="small"
            sx={{
              mt: -0.5,
              color: 'text.secondary',
              '&:hover': { bgcolor: 'action.hover', color: 'text.primary' },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {children}
      </Box>
    </Drawer>
  )
}
